import { UtilitarioService } from '@app/services/utilitario.service';

export class ListaChequePesquisaFiltros {

  DataInicial: string;
  DataFinal: string;
  BancoId: number;
  EstadoTipo: any;
  Estado: number;
  TipoDrId: number;
  TipoData: string;
  TipoCreditoDebito: string;
  Pagina: number;
  Ficha: string;
  ContaId: number;
  Gerencial: boolean;

  constructor() {
    this.Gerencial = true;
    this.DataInicial = UtilitarioService.retornaDataAtualMaisDias(0);
    this.DataFinal = UtilitarioService.retornaDataAtualMaisDias(14);
    this.EstadoTipo = [{ value: 0, descricao: 'A Compensar' },
    { value: 1, descricao: 'Compensados' },
    { value: null, descricao: 'Todos' },
    ];
    this.Estado = 0;
    this.TipoDrId = null;
    this.BancoId = null;
    this.TipoData = 'DataVencimento';
    this.Pagina = 1;

  }
}
